import { css } from '@linaria/core';
import { baseTheme, breakpoints } from 'styles/utils';
export const stepsContainer = "odules__Home__CodeSnippet__CodeSteps_styles_ts-stepsContainer-s1dca4c9";
export const appsListIcon = "odules__Home__CodeSnippet__CodeSteps_styles_ts-appsListIcon-a1es0o0y";

require("./CodeSteps.styles.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./CodeSteps.styles.ts");